import { render, staticRenderFns } from "./StyleEditTabFabrics.vue?vue&type=template&id=1d330a19&"
import script from "./StyleEditTabFabrics.vue?vue&type=script&lang=js&"
export * from "./StyleEditTabFabrics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports